import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import Togglebox from "../../components/togglebox/togglebox";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";
import { validateItemName } from "../../utilities/Validation";
import { useDialog } from "../dialog/DialogContext";
import Label from "../label/label";

interface AccountProps {
    currentItem: any,
}

const LDAPAccountCard: FC<AccountProps> = ({ currentItem }) => {
    const { errors, values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();
    const dialog = useDialog();

    const errorHandler = (accessor) => {
        const error = accessor.split('.').reduce((previous, current) => { return previous?.[current] }
            , errors as any);
        if (error) {
            return <span className='text-red-600 text-xs'>{error}</span>
        } else {
            return null;
        }
    };

    const onEnabled = () => {
        const newEnabledState = !values.enabled;
        setFieldValue("enabled", newEnabledState);
    }

    return (
        <div className="w-full p-2 inline-flex justify-start items-top bg-white">
            <div className="py-4 px-8 mb-1">
                <div className="flex flex-row justify-between items-end" id="connectionNameLabel">
                    <Label htmlFor="details.connectionName.value" required
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.connectionName)}:</Label>
                    {errorHandler("details.connectionName.value")}
                </div>
                <Field id='connectionNameInputFieldId'
                    type="text"
                    name="details.connectionName.value"
                    autoFocus
                    className="flex flex-row items-center p-1 text-gray-800 text-sm w-full bg-gray-input"
                    validate={(value) => validateItemName(value, translate)} />
            </div>
            <div className="py-4 px-8 mb-1">
                <div className="flex flex-row justify-between" id="enabled">
                    <Label htmlFor="enabled" className="text-xs text-gray-600 mt-1">
                        {translate.byKey(TranslationKeys.enabled)}:
                    </Label>
                </div>
                <Togglebox name="enabled" onChanged={onEnabled} label={""} />
            </div>
        </div>
    )
}

export default LDAPAccountCard;
